/** @module Apparel/PriceList/ChangePriceListConfigFormController */
define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "csi/_base/underscore",
    "csi/def",
    "csi/def/Field",
    "csi/enums",
    "csi/form/Widget",
    "csi/locale",
    "csi/xml"
], function(declare,lang,_,def,Field,enums,Widget,locale,xml) {

    return declare(Widget, {

        /**
         * Adds 2 custom enum fields to the form
         */
        _resolveView: function() {

            var style = this.getViewNode();
            var cache = this.getSourceView().getCache();
            var dataSheets = cache.getNodes(style.DataSheets);

            var priceLists = _.filter(dataSheets, function(ds) {
                return ds && ds.$Type == "PriceList";
            });

            var priceListRev = cache.getNode(cache.getNode(this.defView.m_formData.m_source.m_urlNode).LatestRevision);

            if (priceListRev) {
                _.each(["PriceForSalesRegionOrCountry", "PriceForColorwayOrSKU"], function(field_id) {

                    this.insertField(lang.mixin(new Field(), {
                        m_label: field_id,
                        idParameter: field_id,
                        m_type: xml.ATTR_ENUM,
                        m_typeControl: def.FIELD_FILTERING_SELECT
                    }), 0);

                    this.addDefaultValue(field_id, priceListRev[field_id]);

                }, this);

            }

           this.inherited(arguments);
        },

        /**
         * Creates the store for the 2 new enum fields
         * @param {Field} field
         * @param {String} value
         */
        getFieldStore: function(field, value) {
            return enums.getStore(field.m_name, value);
        },

        /**
         * Adds warning on top of the form, below the header
         * @param {Deferred[]} dfds
         */
        onViewStart: function(dfds) {
            this.invalidNode.set("icon", this.invalidNode.WARNING);
            this.invalidNode.set("value", locale.resource("ChangePriceListConfig_Warning"));
            this.inherited(arguments);
        }

    });
});